import React from 'react';
import './HRCompliance.css';

const HRCompliance = () => {
  return (
    <div className="hr-compliance-page">
      {/* HERO SECTION */}
      <section className="hero-HR">
        <div className="hero-content-HR">
          <div className="hero-badge-HR">HR Compliance & Advisory</div>
          <h1>Stay Ahead of Every <span className="highlight">Regulatory Change</span></h1>
          <p>Our expert HR advisory team ensures your workforce solutions remain fully compliant with Indian labour laws, GST, and all statutory requirements — so you can focus on growing your business.</p>
          <div className="hero-stats">
            <div>
              <div className="stat-num">100<sup>+</sup></div>
              <div className="stat-label">Businesses Compliant</div>
            </div>
            <div>
              <div className="stat-num">7<sup>+</sup></div>
              <div className="stat-label">Years of Expertise</div>
            </div>
            <div>
              <div className="stat-num">100<sup>%</sup></div>
              <div className="stat-label">Audit Success Rate</div>
            </div>
            <div>
              <div className="stat-num">10<sup>+</sup></div>
              <div className="stat-label">States Covered</div>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <img src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=900&q=80&fit=crop" alt="HR compliance team at work" />
        </div>
      </section>

      {/* TRUST BAR */}
      <div className="trust-bar">
        <span className="trust-label">Trusted for</span>
        <div className="trust-items">
          <div className="trust-item"><div className="trust-dot"></div>PF & ESI Registration</div>
          <div className="trust-item"><div className="trust-dot"></div>Shops & Establishments Act</div>
          <div className="trust-item"><div className="trust-dot"></div>Contract Labour Regulation</div>
          <div className="trust-item"><div className="trust-dot"></div>Minimum Wages Compliance</div>
          <div className="trust-item"><div className="trust-dot"></div>GST Advisory</div>
          <div className="trust-item"><div className="trust-dot"></div>Annual Returns Filing</div>
          <div className="trust-item"><div className="trust-dot"></div>Labour Code Implementation</div>
        </div>
      </div>

      {/* SERVICES */}
      <section className="services" id="services">
        <div className="services-header-HR">
          <div>
            <div className="section-tag-HR" style={{ justifyContent: 'start' }}>What We Do</div>
            <div className="section-title">Comprehensive Compliance Services</div>
          </div>
          <div className="section-sub">End-to-end statutory management tailored for Indian enterprises — from startups to large corporates.</div>
        </div>
        <div className="cards-grid">
          <div className="card">
            <div className="card-icon-HR icon-green">⚖️</div>
            <h3>Labour Law Compliance</h3>
            <p>Complete advisory on Factories Act, Shops & Establishments, Contract Labour, and four new Labour Codes — ensuring seamless implementation across your workforce.</p>
            <div className="card-tags">
              <span className="tag tag-green">Factories Act</span>
              <span className="tag tag-green">CLRA</span>
              <span className="tag tag-green">Labour Codes 2020</span>
            </div>
          </div>
          <div className="card">
            <div className="card-icon-HR icon-blue">🏛️</div>
            <h3>Statutory Registrations</h3>
            <p>Seamless PF, ESI, PT, and LWF registrations across all states with timely challan payments, return filings, and digital record maintenance.</p>
            <div className="card-tags">
              <span className="tag tag-blue">EPF/PF</span>
              <span className="tag tag-blue">ESI</span>
              <span className="tag tag-blue">Professional Tax</span>
            </div>
          </div>
          <div className="card">
            <div className="card-icon-HR icon-green">💰</div>
            <h3>GST & Tax Advisory</h3>
            <p>Guidance on GST applicability for HR services, input tax credit optimization, and full compliance reporting for workforce and staffing solutions.</p>
            <div className="card-tags">
              <span className="tag tag-green">GST Filing</span>
              <span className="tag tag-green">ITC Advisory</span>
              <span className="tag tag-green">Tax Planning</span>
            </div>
          </div>
          <div className="card">
            <div className="card-icon-HR icon-blue">📊</div>
            <h3>Payroll Compliance</h3>
            <p>TDS computation, Form 16 generation, salary structure optimization, and complete payroll audit support under Income Tax Act and applicable regulations.</p>
            <div className="card-tags">
              <span className="tag tag-blue">TDS</span>
              <span className="tag tag-blue">Form 16/24Q</span>
              <span className="tag tag-blue">Payroll Audit</span>
            </div>
          </div>
          <div className="card">
            <div className="card-icon-HR icon-green">🔍</div>
            <h3>Compliance Audits</h3>
            <p>Proactive audits to identify gaps before regulatory inspections. Includes detailed gap analysis reports and prioritized corrective action roadmaps.</p>
            <div className="card-tags">
              <span className="tag tag-green">Gap Analysis</span>
              <span className="tag tag-green">Risk Assessment</span>
            </div>
          </div>
          <div className="card">
            <div className="card-icon-HR icon-blue">📜</div>
            <h3>Policy & Documentation</h3>
            <p>Drafting and legal review of employment contracts, HR policies, certified standing orders, and POSH compliance frameworks to protect your organization.</p>
            <div className="card-tags">
              <span className="tag tag-blue">POSH</span>
              <span className="tag tag-blue">Standing Orders</span>
              <span className="tag tag-blue">HR Policies</span>
            </div>
          </div>
        </div>
      </section>

      {/* COMPLIANCE COVERAGE */}
      <section className="compliance" id="coverage">
        <div className="compliance-intro">
          <div>
            <div className="section-tag-HR">Regulatory Coverage</div>
            <div className="section-title">Every Statute. Every State.</div>
          </div>
          <div className="section-sub">We handle the full spectrum of Indian labour and tax legislation applicable to your workforce, across multiple states and union territories.</div>
        </div>
        <div className="compliance-grid">
          <div className="compliance-panel">
            <div className="panel-head">
              <div className="panel-icon icon-green">⚖️</div>
              <h3>Central Labour Laws</h3>
            </div>
            <ul className="compliance-list">
              <li><span className="check check-green">✓</span> Employees' Provident Fund & MP Act, 1952</li>
              <li><span className="check check-green">✓</span> Employees' State Insurance Act, 1948</li>
              <li><span className="check check-green">✓</span> Contract Labour (Regulation & Abolition) Act, 1970</li>
              <li><span className="check check-green">✓</span> Maternity Benefit Act, 1961</li>
              <li><span className="check check-green">✓</span> Payment of Gratuity Act, 1972</li>
              <li><span className="check check-green">✓</span> Payment of Wages Act, 1936</li>
              <li><span className="check check-green">✓</span> The Four New Labour Codes (2019–2020)</li>
            </ul>
          </div>
          <div className="compliance-panel">
            <div className="panel-head">
              <div className="panel-icon icon-blue">🗂️</div>
              <h3>Tax & State Compliance</h3>
            </div>
            <ul className="compliance-list">
              <li><span className="check check-blue">✓</span> Goods & Services Tax (GST) — HR Services</li>
              <li><span className="check check-blue">✓</span> Income Tax — TDS, Form 24Q / 26Q</li>
              <li><span className="check check-blue">✓</span> Professional Tax (State-wise, all states)</li>
              <li><span className="check check-blue">✓</span> Labour Welfare Fund (LWF)</li>
              <li><span className="check check-blue">✓</span> Shops & Establishments Act (Multi-State)</li>
              <li><span className="check check-blue">✓</span> Minimum Wages Act — State Notifications</li>
              <li><span className="check check-blue">✓</span> Industrial Disputes Act, 1947</li>
            </ul>
          </div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="process-HR" id="process-HR">
        <div style={{ textAlign: 'center', marginBottom: '0' }}>
          <div className="section-tag-HR" style={{ textAlign: 'center' }}>How We Work</div>
          <div className="section-title" style={{ textAlign: 'center', maxWidth: '100%' }}>Your Compliance Journey</div>
          <p className="section-sub" style={{ margin: '0 auto', textAlign: 'center' }}>A structured, transparent process from first consultation to ongoing compliance management.</p>
        </div>
        <div className="process-steps-HR">
          <div className="step-HR">
            <div className="step-num-HR">01</div>
            <h4>Initial Assessment</h4>
            <p>Free compliance health check to understand your current statutory status and identify priority gaps.</p>
          </div>
          <div className="step-HR">
            <div className="step-num-HR">02</div>
            <h4>Gap Analysis Report</h4>
            <p>Detailed written report of all non-compliances, risk ratings, and a prioritized action plan.</p>
          </div>
          <div className="step-HR">
            <div className="step-num-HR">03</div>
            <h4>Implementation</h4>
            <p>Our advisors handle registrations, filings, documentation, and corrections on your behalf.</p>
          </div>
          <div className="step-HR">
            <div className="step-num-HR">04</div>
            <h4>Ongoing Monitoring</h4>
            <p>Continuous compliance tracking, regulatory alerts, and quarterly review meetings.</p>
          </div>
        </div>
      </section>

      {/* WHY KRISHPAR */}
      <section className="why-HR" id="why-HR">
        <div className="section-tag-HR" style={{textAlign:'center'}}>Why Krishpar</div>
        <div className="section-title" style={{textAlign:'center'}}>Built for Indian Compliance</div>
        <div className="section-sub">A decade of deep expertise in India's complex, state-specific regulatory landscape — so nothing falls through the cracks.</div>
        <div className="pillars">
          <div className="pillar">
            <div className="pillar-num">01</div>
            <h4>Dedicated Advisors</h4>
            <p>Named compliance managers who know your business, your industry sector, and your state-specific obligations inside out.</p>
          </div>
          <div className="pillar">
            <div className="pillar-num">02</div>
            <h4>Proactive Alerts</h4>
            <p>Advance notification of regulatory changes, gazette notifications, and deadline reminders — before they become liabilities.</p>
          </div>
          <div className="pillar">
            <div className="pillar-num">03</div>
            <h4>Inspector-Ready Records</h4>
            <p>All registers, records, and returns maintained audit-ready at all times for labour, GST, and income tax inspections.</p>
          </div>
          <div className="pillar">
            <div className="pillar-num">04</div>
            <h4>Pan-India Reach</h4>
            <p>Coverage across key states and union territories with jurisdiction-specific expertise for every location.</p>
          </div>
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="industries" id="industries">
        <div style={{ textAlign: 'center', marginBottom: '0' }}>
          <div className="section-tag-HR" style={{ textAlign: 'center' }}>Industries We Serve</div>
          <div className="section-title" style={{ textAlign: 'center', maxWidth: '100%' }}>Compliance Across Every Sector</div>
          <p className="section-sub" style={{ margin: '0 auto', textAlign: 'center' }}>Sector-specific expertise so our advice is relevant, not generic.</p>
        </div>
        <div className="industry-grid">
          <div className="industry-card">
            <div className="ic-icon">🏭</div>
            <h4>Manufacturing</h4>
            <p>Factories Act, Contract Labour, and shift-worker compliance.</p>
          </div>
          <div className="industry-card">
            <div className="ic-icon">💻</div>
            <h4>IT & Technology</h4>
            <p>Startup-friendly PF/ESI structuring and STPI compliance advisory.</p>
          </div>
          <div className="industry-card">
            <div className="ic-icon">🛒</div>
            <h4>Retail & E-commerce</h4>
            <p>Multi-state Shops Act registrations and gig workforce compliance.</p>
          </div>
          <div className="industry-card">
            <div className="ic-icon">🏥</div>
            <h4>Healthcare</h4>
            <p>Clinical establishment regulations and healthcare worker statutory benefits.</p>
          </div>
          <div className="industry-card">
            <div className="ic-icon">🚚</div>
            <h4>Logistics</h4>
            <p>Motor Transport Act compliance, driver benefits, and multi-state operations.</p>
          </div>
          <div className="industry-card">
            <div className="ic-icon">🏗️</div>
            <h4>Construction</h4>
            <p>BOCW Act registration, cess compliance, and contract labour management.</p>
          </div>
          <div className="industry-card">
            <div className="ic-icon">🎓</div>
            <h4>Education</h4>
            <p>Education sector HR policies, POSH compliance, and statutory benefits.</p>
          </div>
          <div className="industry-card">
            <div className="ic-icon">🏦</div>
            <h4>BFSI</h4>
            <p>Financial sector HR compliance, gratuity trusts, and superannuation management.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section-HR" id="contact-HR">
        <div className="cta-box">
          <div className="section-tag-HR">Get In Touch</div>
          <div className="section-title">Talk to Us</div>
          <p>Have a compliance question or need expert guidance? Our advisors are here to help — reach out and we'll get back to you promptly.</p>
          <div className="cta-actions">
            <a href="/contact#form-section" className="btn-green">Send Us a Message</a>
            {/* <a href="tel:+919876543210" className="btn-blue-outline">Talk to us</a> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HRCompliance;
